import React from 'react';
import AdvertisementPaymentCancellationContainer from 'containers/AdvertisementPaymentCancellationContainer';

export default function AdvertisementPaymentCancellationPage() {
  return <AdvertisementPaymentCancellationContainer />;
}
